import { Service } from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len
import { ServiceQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export const GET_SERVICES_FROM_SERVER = '[LABOUR OPERATIONS] Get Services From Server';
export class GetServicesFromServer implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_SERVICES_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: ServiceQueryParameters) {}
}

export const GET_SERVICES_FROM_SERVER_SUCCESS = '[LABOUR OPERATIONS] Get Services From Server Success';
export class GetServicesFromServerSuccess implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_SERVICES_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = true;
  constructor(public payload: { services: Service[] }) {}
}

export const GET_SERVICES_FROM_SERVER_FAILURE = '[LABOUR OPERATIONS] Get Services From Server Failure';
export class GetServicesFromServerFailure implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_SERVICES_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type ServicesAction = GetServicesFromServer | GetServicesFromServerSuccess | GetServicesFromServerFailure;
